<template>
  <div class='RegisterProd'>
    <RegisterProdDesktop/>
    <RegisterProdMobile/>
  </div>
</template>

<script>
import RegisterProdDesktop from './RegisterProdDesktop'
import RegisterProdMobile from './RegisterProdMobile'
export default {
  name: 'RegisterProd',
  components: { RegisterProdDesktop, RegisterProdMobile }
}
</script>

<style scoped>
.RegisterProd {
  width: 100%;
  height: 100%;
}
</style>
